import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const TYPOGRAPHY_CLASSES = [
  'body-regular',
  'body-regular-responsive',
  'body-semibold-responsive',
  'body-responsive',
  'body-medium',
  'body-semibold',
  'body-bold',
  'body-small',
  'button-regular',
  'button-medium',
  'button-semibold',
  'button-bold',
  'ltp-cn-body-bold',
  'tp-body-small',
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: TYPOGRAPHY_CLASSES }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
